// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1037":"0ef25c226af0832a7edb","4056":"95fc0fa5aff267087a25"}[chunkId] + ".min.css";
};